"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.googleMapsLoader = void 0;
var js_api_loader_1 = require("@googlemaps/js-api-loader");
exports.googleMapsLoader = new js_api_loader_1.Loader({
    apiKey: "AIzaSyCh6lA9bwpWH48z6GuZMTM9Q8zaZ5RAhF4",
    version: "beta"
});
